
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {createPaymentMethod} from 'redux/modules/billing/actions'
import {fetchMerchant} from 'redux/modules/merchants/actions'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import {batchActions} from 'redux-batch-enhancer'
import PromptContainer from 'components/PromptContainer'
import ButtonsGroup from 'components/ButtonsGroup'
import FormInput from 'components/FormInput'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import isCreditCard from 'validator/lib/isCreditCard'
import matches from 'validator/lib/matches'
import formatCreditCard from 'utils/formatCreditCard'

export class PaymentDetailsModal extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    closeModal: PropTypes.func,
    error: PropTypes.string
  }

  render() {
    const {handleSubmit, closeModal, submitting} = this.props

    return (
      <PromptContainer
        className='payment-details-view'
        title='Payment Details'
        onClose={closeModal}
      >
        <form onSubmit={handleSubmit}>
          {submitting ? <Loader /> : null}
          {this.renderType()}
          {this.renderCardDetails()}
          {this.renderFooter()}
        </form>
      </PromptContainer>
    )
  }

  renderType() {
    const {submitting} = this.props

    return (
      <div className='payment-details-view_type'>
        <Field
          name='type'
          type='radio'
          value='card'
          label={
            <div className='payment-details-view_type_icons'>
              <Icon name='visa' width='39px' height='22px' />
              <Icon name='mastercard' width='39px' height='22px' />
              <Icon name='americanexpress' width='39px' height='22px' />
            </div>
          }
          disabled={submitting}
          component={FormInput}
        />
      </div>
    )
  }

  renderCardDetails() {
    const {submitting} = this.props

    return (
      <div className='payment-details-view_card'>
        <Field
          className='payment-details-view_card_number'
          name='cardNumber'
          autoFocus
          label='Credit Card Number'
          disabled={submitting}
          normalize={(value, previousValue) => {
            const processedValue = value && value.replace(/[^0-9]+/g, '')
            return formatCreditCard(processedValue)
          }}
          component={FormInput}
        />
        <Field
          className='payment-details-view_card_cvv'
          name='cardCvv'
          label={
            <div>
              Security Code
              <Icon className='payment-details-view_card_cvv_icon' name='question' size='12px' tooltip='CVV code' />
            </div>}
          disabled={submitting}
          normalize={(value, previousValue) => {
            const processedValue = value.replace(/[^0-9]+/g, '')
            if (processedValue.length > 4) return previousValue
            return processedValue
          }}
          component={FormInput}
        />
        <Field
          className='payment-details-view_card_expire'
          name='cardExpire'
          label='Expiry date'
          placeholder='MM/YYYY'
          disabled={submitting}
          normalize={(value, previousValue) => {
            const processedValue = value.replace(/[^0-9/]+/g, '')
            if (processedValue.length > 7) return previousValue
            return processedValue
          }}
          component={FormInput}
        />
        {this.renderError()}
      </div>
    )
  }

  renderFooter() {
    const {submitting, invalid, closeModal} = this.props

    return (
      <div className='payment-details-view_footer'>
        <div className='payment-details-view_footer_disclaimer'>
          Please note: changing your billing location may change your applicable tax rate.
        </div>
        <ButtonsGroup align='right'>
          <button type='button' onClick={closeModal}>Cancel</button>
          <button type='submit' disabled={submitting || invalid}>Save</button>
        </ButtonsGroup>
      </div>
    )
  }

  renderError() {
    const {error} = this.props
    if (!error) return null

    return <div className='payment-details-view_error'>{error}</div>
  }
}

const mapStateToProps = state => ({
  initialValues: {
    type: 'card'
  }
})
const mapDispatchToProps = {
  closeModal
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'paymentDetails',
  validate: ({cardNumber, cardCvv, cardExpire}) => {
    const errors = {}

    if (cardNumber && !isCreditCard(cardNumber)) {
      errors.cardNumber = 'Wrong format for credit card number'
    }

    if (cardExpire && !matches(cardExpire, /(\d){2}\/(\d){4}/ig)) {
      errors.cardExpire = 'Wrong expiration date format'
    }

    if (!cardCvv) {
      errors.cardCvv = 'Missing CVV code'
    } else if (cardCvv && cardCvv.length < 3) {
      errors.cardCvv = 'Wrong CVV code format'
    }

    return errors
  },
  onSubmit: (values, dispatch) => new Promise((resolve, reject) => {
    const {type, cardNumber, cardCvv, cardExpire} = values
    dispatch(createPaymentMethod({type, cardNumber, cardCvv, cardExpire}))
      .success(response => {
        dispatch(batchActions([
          closeModal(),
          fetchMerchant()
        ]))

        resolve()
      })
      .fail(err => {
        reject(new SubmissionError({_error: err}))
      })
  })
})(PaymentDetailsModal))



// WEBPACK FOOTER //
// ./client/modals/PaymentDetailsModal/index.js